import { saveAs } from 'file-saver';

export const downloadFile = (data, filename) => {
  console.log(data);
  let blob = new Blob([data], {type: "application/zip"});  
  saveAs(blob, `${filename}.zip`)
}



// WEBPACK FOOTER //
// ./src/utils/index.js